// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  // Icon,
  CircularProgress,
  // LinearProgress,
  Backdrop,
  Table,
  // TableHead,
  TableContainer,
  TableCell,
  TableBody,
  TableRow,
  Paper,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
// import DataTable from "theme/Tables/DataTable";
// import MDButton from "theme/components/MDButton";
import MDBadge from "theme/components/MDBadge";
import usePageTitle from "app/pageTitle";
import ApiConfig from "apiConfig";

function SwitchTransaction() {
  const pageTitle = "Switch Transaction";
  usePageTitle(pageTitle);

  const { reference } = useParams();

  const [refreshPage, setRefreshPage] = useState(false);
  const [refreshStarted, setRefreshStarted] = useState(null);
  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [switchTransaction, setSwitchTransaction] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`switch/${reference}/get.json`)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            setSwitchTransaction(result.data.data.transaction);
            if (result.data.data.transaction.closed === false) {
              if (refreshStarted !== null) {
                clearInterval(refreshStarted);
              }
              const id = setInterval(() => setRefreshPage(!refreshPage), 30000);
              setRefreshStarted(id);
            }
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred. Please try again later.");
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  function getStatusColor(stat) {
    let statusColor = "warning";
    if (stat.toUpperCase() === "COMPLETED") {
      statusColor = "success";
    } else if (stat.toUpperCase() === "SELLER-DECLINED") {
      statusColor = "dark";
    } else if (stat.toUpperCase() === "ERROR") {
      statusColor = "error";
    } else if (stat.toUpperCase() === "FAILED") {
      statusColor = "error";
    } else if (stat.toUpperCase() === "AWAITING-SELLER-PAYMENT") {
      statusColor = "info";
    } else {
      statusColor = "warning";
    }

    return statusColor;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid
              container
              spacing={3}
              display="flex"
              alignItems="center"
              justifyContent="space-evenly"
            >
              <Grid item xs={12} md={9} lg={9}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={0}>
                      <MDBox p={3} display="flex" justifyContent="space-between" mb={1}>
                        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                          Switch Transaction
                        </MDTypography>
                        {switchTransaction !== null ? (
                          <MDBadge
                            badgeContent={switchTransaction.status}
                            variant="contained"
                            container
                            color={getStatusColor(switchTransaction.status)}
                          />
                        ) : (
                          <MDBadge badgeContent="---" variant="contained" container color="dark" />
                        )}
                      </MDBox>
                      <MDBox sx={{ textAlign: "center" }} pr={3} mb={5}>
                        {switchTransaction === null ? (
                          <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                            ---
                          </MDTypography>
                        ) : (
                          <MDTypography variant="h6" fontWeight="light">
                            {switchTransaction.status_message}
                          </MDTypography>
                        )}
                      </MDBox>
                      <MDBox mt={1}>
                        <TableContainer component={Paper}>
                          <Table aria-label="simple table">
                            {switchTransaction === null ? (
                              <TableBody>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    No data
                                  </TableCell>
                                  <TableCell align="right">received</TableCell>
                                </TableRow>
                              </TableBody>
                            ) : (
                              <TableBody>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Reference
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="medium">
                                      {switchTransaction.reference}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      From
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDBox
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="right"
                                    >
                                      <img
                                        alt=""
                                        src={`${ApiConfig.api_media_url}${switchTransaction.source.wallet.logo}`}
                                        width="25"
                                      />
                                      <MDBox ml={2}>
                                        <MDTypography variant="h6" fontWeight="medium">
                                          {switchTransaction.source.wallet !== "ALERO"
                                            ? switchTransaction.source.wallet.title
                                            : "Alero Africa"}
                                        </MDTypography>
                                      </MDBox>
                                    </MDBox>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      To
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDBox
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="right"
                                    >
                                      <img
                                        alt=""
                                        src={`${ApiConfig.api_media_url}${switchTransaction.destination.wallet.logo}`}
                                        width="25"
                                      />
                                      <MDBox ml={2}>
                                        <MDTypography variant="h6" fontWeight="medium">
                                          {switchTransaction.destination.wallet !== "ALERO"
                                            ? switchTransaction.destination.wallet.title
                                            : "Alero Africa"}
                                        </MDTypography>
                                      </MDBox>
                                    </MDBox>
                                  </TableCell>
                                </TableRow>

                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      You Pay
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="medium">
                                      {switchTransaction.source.currency.symbol}{" "}
                                      {(
                                        switchTransaction.amount /
                                        switchTransaction.destination.currency.multiplier
                                      ).toLocaleString("en-US", {
                                        minimumFractionDigits:
                                          switchTransaction.source.currency.multiplier.toString()
                                            .length - 1,
                                        maximumFractionDigits:
                                          switchTransaction.source.currency.multiplier.toString()
                                            .length - 1,
                                      })}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Exchange Rate
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="medium">
                                      {switchTransaction.destination.currency.symbol}{" "}
                                      {switchTransaction.exchange_rate}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Transaction Fee
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="medium">
                                      {switchTransaction.source.currency.symbol}{" "}
                                      {(
                                        switchTransaction.transaction_fee /
                                        switchTransaction.destination.currency.multiplier
                                      ).toLocaleString("en-US", {
                                        minimumFractionDigits:
                                          switchTransaction.source.currency.multiplier.toString()
                                            .length - 1,
                                        maximumFractionDigits:
                                          switchTransaction.source.currency.multiplier.toString()
                                            .length - 1,
                                      })}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      You Get
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="medium">
                                      {switchTransaction.destination.currency.symbol}{" "}
                                      {(
                                        switchTransaction.credit_amount /
                                        switchTransaction.destination.currency.multiplier
                                      ).toLocaleString("en-US", {
                                        minimumFractionDigits:
                                          switchTransaction.destination.currency.multiplier.toString()
                                            .length - 1,
                                        maximumFractionDigits:
                                          switchTransaction.destination.currency.multiplier.toString()
                                            .length - 1,
                                      })}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                {switchTransaction.destination.wallet.code !== "ALERO" ? (
                                  <TableRow
                                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                  >
                                    <TableCell component="th" scope="row">
                                      <MDTypography variant="h6" fontWeight="light">
                                        {switchTransaction.destination.wallet.title} Details
                                      </MDTypography>
                                    </TableCell>
                                    <TableCell align="right">
                                      <MDTypography variant="h6" fontWeight="light">
                                        {switchTransaction.destination.wallet_details.map(
                                          (detail) => (
                                            <MDBox mb={1}>
                                              <MDTypography variant="text">
                                                <b>{detail.display_name}</b>: {detail.value}
                                              </MDTypography>
                                            </MDBox>
                                          )
                                        )}
                                      </MDTypography>
                                    </TableCell>
                                  </TableRow>
                                ) : (
                                  <> </>
                                )}

                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Status
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {switchTransaction.closed ? "Closed" : "Open"}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Status Message
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {switchTransaction.status_message}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Initiated On
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {switchTransaction.created}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            )}
                          </Table>
                        </TableContainer>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
                {switchTransaction === null ? (
                  <> </>
                ) : (
                  <MDBox>
                    {switchTransaction.closed ? (
                      <> </>
                    ) : (
                      <MDBox mt={3}>
                        <Card sx={{ height: "100%", marginTop: "0px" }}>
                          <MDBox p={0}>
                            <MDBox ml={3} mt={3} display="flex" justifyContent="space-between">
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                textTransform="capitalize"
                              >
                                Payment Information
                              </MDTypography>
                            </MDBox>
                            <MDBox ml={2} mt={1} p={1} mb={2}>
                              <MDTypography variant="h6" fontWeight="light">
                                {switchTransaction.invoice.instructions}
                              </MDTypography>
                              {switchTransaction.invoice.type === "redirect" ? (
                                <MDBox mt={2} mb={2}>
                                  <MDButton
                                    variant="outlined"
                                    color="dark"
                                    size="medium"
                                    onClick={() =>
                                      window.open(
                                        switchTransaction.invoice.data.redirect_url,
                                        "_blank"
                                      )
                                    }
                                  >
                                    <MDBox display="flex" alignItems="center" justifyContent="left">
                                      <img
                                        alt=""
                                        src={`${ApiConfig.api_media_url}${switchTransaction.source.wallet.logo}`}
                                        width="20"
                                        mr={3}
                                      />
                                      <MDBox ml={2}>Pay Now</MDBox>
                                    </MDBox>
                                  </MDButton>
                                </MDBox>
                              ) : (
                                <> </>
                              )}
                            </MDBox>
                          </MDBox>
                        </Card>
                      </MDBox>
                    )}
                  </MDBox>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default SwitchTransaction;
